import { render, staticRenderFns } from "./KasProduksiFiber.vue?vue&type=template&id=d7081816"
import script from "./KasProduksiFiber.vue?vue&type=script&lang=js"
export * from "./KasProduksiFiber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports